<template>
	<section>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
            <compFormQuery :col="2" v-if="querytype=='query'" class="margin-layout" :formdata="getBase" :value="formData"></compFormQuery>
		    <compFormEdit :col="2" v-else class="margin-layout" ref="formbase" :formdata="getBase" v-model="formData" ></compFormEdit>
        </compWrapper>
		<div class="text-right" v-if="querytype!='query'">
			<vButton
				class="margin-10"
				theme="primary"
				@click="save"
			>{{$t('global.common.save',{defaultValue:'保存'})}}</vButton>
			<vButton class="margin-10" @click="close">{{$t('global.common.close',{defaultValue:'关闭'})}}</vButton>
		</div>
		<vLoading size="large" transfer :loading="loading"></vLoading>
        <!-- 添加modal -->
		<vModal
			class="hidefooter customerupload"
			v-model="operate.show"
			:title="operate.title"
			v-bind="operate"
		>
			<searchCategory @on-chosedata="chosecategory" @on-close="closemodal"></searchCategory>
			<footer slot="footer" v-show="false"></footer>
		</vModal>
	</section>
</template>

<script>
import { HttpSaveLineMaintain, HttpGetLineMaintainOne } from '@/service/setting';
// 搜索品类
import searchCategory from "@/views/products/searchcategory/index";
import {
	HttpGetCategories,
} from '@/service/products/allproducts'
import mixin from "./mixin";
import { mapGetters } from "vuex";
export default {
	props: ['activeid','querytype'],
    mixins: [mixin],
    components: {
        searchCategory
    },
	data() {
		return {
			loading: false,
			formData: {},
            titleName: "",
            categoryList: [],
			operate: {
				id: null,
				title: "",
				show: false,
				component: null
			},
		};
	},
	created() {
		this.getDetail();
		if(this.querytype != 'query'){
			// 放入品类各个名称
			this.getCategory()
		}
	},
	computed: {
        ...mapGetters('dictionary', ['getNewAllProductWithoutOrgList','getAccountList']),
        ...mapGetters('diction', ['getNewProductList', 'getNewAccountList']),
		getBase() {
			return [
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: "lineId",
                    tag: 'vSelect',
                    options: this.getNewProductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "目标类型",
                    key: "targetType",
                    tag: "vSelect",
                    options: this.getTargetType
                },
                // {
                // 	// label: this.$t('global.common.channel',{defaultValue:'渠道'}),
                //     label:'渠道',
                // 	key: "accountFlag",
                // 	tag: 'vSelect',
                // 	options: this.getNewAccountList,
                //     props: {
                //         filterable: true,
                //     }
                // }, 
                {
                    label: "业务类型",
                    key: "bussinessType",
                    tag: "vSelect",
                    options: this.getBussinessType
                },
                {
                    label: '日期',
                    tag: 'vDatepicker',
                    key: 'targetMonth',
                    props: {
                        format: 'yyyy-mm',
                        confirm: false,
                    },
                }, 
                {
                    label: '目标值(USD)',
                    key: "targetValue",
                    tag: 'vInputNumber',
                    props:{
                        min:0
                    }
                },
                
                {
                    label: this.$t('erp.product.category',{defaultValue:'品类'}),
                    key: "category",
                    required: true,
                    show:this.querytype !='query',
                    children: (h) => {
                        return <vIcon
                            title={this.$t('erp.product.search_category',{defaultValue:'搜索品类'})}
                            type="search"
                            center
                            slot="suffix"
                            style="padding:6px;pointer-events: initial;"
                            size="18"
                            nativeOnClick={this.handleModalplat.bind(this)}
                        />
                    },
                    props: {
                        readonly: true,
                        placeholder:this.$t('erp.product.select_category',{defaultValue:'请选择品类'})
                    },
                    span: 24
                },
                {
                    label: this.$t('erp.product.category',{defaultValue:'品类'}),
                    key: "category",
                    show:this.querytype=='query',
                    span:24,
                },
                // 单独品类
                {
                    span:24,
                    show:this.formData.category !='' && this.formData.category !=null && this.formData.category !=undefined && this.type!='query',
                    valueText:this.titleName || this.formData.categoryName,
                    query:true,
                },
                {
                    span:24,
                    show:this.type=='query',
                    valueText:this.formData.categoryName,
                    query:true,
                },
			];
		},
	},
	methods: {
        chosecategory(data){
			// console.log(data)
			this.$set(this.formData,'category',data.code)
			// 品类获取
			let array = this.getParentItem(data.id);
			let newarr = []
			// console.log(array)
			for(var i = array.length-1;i>=0;i--){
				newarr.push(array[i])
			}
			let title = newarr[1].name + "(" + newarr[1].nameEn + ") /" + newarr[2].name + "(" + newarr[2].nameEn + ") /" + newarr[3].name + "(" + newarr[3].nameEn + ")"

			this.$set(this.$data,'titleName',title)
		},
		getParentItem(parentId,result=[]){
			// console.log(this.categoryList)
			let parent = this.categoryList.find(val=> val.id == parentId)
			if(parent){
				result.push(parent)
			}
			if(parent && parent.parentId){
				this.getParentItem(parent.parentId,result)
			}
			return result

		},
		handleModalplat(){
			this.operate={
				show:true,
				title:this.$t('erp.product.search_category',{defaultValue:'搜索品类'}),
				width:650,
			}
		},
		closemodal(){
			this.operate.show = false;
		},
		// 请求品类列表
		getCategory(){
			HttpGetCategories().then(res=>{
				this.categoryList = res.data
			},err=>{
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		getDetail() {
            if(this.querytype =='add') return ;
			this.loading = true;
			HttpGetLineMaintainOne({ id: this.activeid }).then(res => {
				this.loading = false;
				this.formData = res.data || {};
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		//更新
		async save() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
            if (this.formData.targetValue < 0) return this.$VMessage.error("目标值不能小于0");
			this.loading = true;
			HttpSaveLineMaintain({
                ...this.formData,
                orgId: global.SYSID
            }).then(() => {
				this.close();
				this.$emit('on-update')
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		close() {
			this.$emit('on-close')
		}
	}
};
</script>
